<section class="vc-admin-treatment-categories-list">
  <app-admin-list-toolbar
    titleKey="ADMIN.TREATMENTS.ALL.CATEGORIES"
    descriptionKey="ADMIN.IA.TREATMENTS.DESCRIPTION"
    [showSearch]="true"
    searchPlaceholderKey="COMMON.SEARCH"
    [searchValue]="searchValue"
    (searchValueChange)="onSearch($event)"
  >
    <button
      toolbar-actions
      pButton
      type="button"
      icon="fas fa-plus"
      class="p-button-sm"
      [label]="'COMMON.ADD' | translate"
      (click)="router.navigate(['/administration', customer_route_param, 'treatments', 'categories', 'new'])"
    ></button>
  </app-admin-list-toolbar>

  @if (filteredTreatmentsCategories.length === 0) {
    <app-admin-state-panel
      mode="empty"
      titleKey="ADMIN.TREATMENTS.CATEGORIES.EMPTY.TITLE"
      descriptionKey="ADMIN.TREATMENTS.CATEGORIES.EMPTY.DESCRIPTION"
    ></app-admin-state-panel>
  } @else {
    <p-table
      [value]="filteredTreatmentsCategories"
      styleClass="Table"
      responsiveLayout="scroll"
      [autoLayout]="true"
      [paginator]="true"
      [rows]="20"
      [rowsPerPageOptions]="[20, 40, 100]"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'COMMON.TREATMENT.CATEGORY.NAME' | translate }}</th>
          <th>{{ 'COMMON.TREATMENT.CATEGORY.TREATMENTS' | translate }}</th>
          <th>{{ 'COMMON.ACTIONS' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-category>
        <tr>
          <td>{{ category.name }}</td>
          <td>{{ category.treatments?.length || 0 }}</td>
          <td>
            <app-admin-table-actions
              [manageRouterLink]="[
                '/administration',
                customer_route_param,
                'treatments',
                'categories',
                category.id
              ]"
              (delete)="confirmDelete(category)"
            ></app-admin-table-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</section>
